import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { API_BASE } from '@/lib/api';

/** Logotipo do Google (cores da marca, exigidas pelas diretrizes do botão "Fazer login com o Google"). */
function GoogleLogo() {
  return (
    <svg viewBox="0 0 48 48" aria-hidden className="size-5">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
      <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
    </svg>
  );
}

/**
 * Entrar ou cadastrar com Google: navegação para a API, que leva ao Google e volta com a sessão aberta
 * (ou à tela de entrada com o motivo da recusa). Sem conta, o cadastro cria um(a) orientador(a).
 */
export function GoogleButton({ next, className, children = 'Continuar com Google' }: { next?: string; className?: string; children?: React.ReactNode }) {
  const href = `${API_BASE}/auth/google${next && next !== '/' ? `?next=${encodeURIComponent(next)}` : ''}`;
  return (
    <Button asChild variant="outline" size="lg" className={cn(className)}>
      <a href={href}>
        <GoogleLogo />
        {children}
      </a>
    </Button>
  );
}

/** Separador "ou" entre o Google e o formulário de e-mail e senha. */
export function OrDivider({ label = 'ou', className }: { label?: string; className?: string }) {
  return (
    <div className={cn('text-muted-foreground flex items-center gap-3 text-xs', className)} aria-hidden>
      <span className="bg-border h-px flex-1" />
      {label}
      <span className="bg-border h-px flex-1" />
    </div>
  );
}
